import { NavLink, useNavigate } from "react-router-dom";
import {
  House,
  WhatsappLogo,
  ClockCounterClockwise,
  Prohibit,
  Gear,
  SignOut,
  Lightning,
  Key,
  Users,
  ChatCircleDots,
} from "@phosphor-icons/react";
import { useAuth } from "@/context/AuthContext";

const items = [
  { to: "/", label: "Dashboard", icon: House, end: true },
  { to: "/whatsapp", label: "WhatsApp", icon: WhatsappLogo },
  { to: "/messages", label: "Mensagens", icon: ChatCircleDots },
  { to: "/contacts", label: "Contatos", icon: Users },
  { to: "/painel-session", label: "Sessão painel.fun", icon: Key },
  { to: "/history", label: "Histórico", icon: ClockCounterClockwise },
  { to: "/blocklist", label: "Bloqueios", icon: Prohibit },
  { to: "/settings", label: "Configurações", icon: Gear },
];

export default function Sidebar() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  return (
    <aside
      data-testid="sidebar"
      className="w-64 shrink-0 h-screen sticky top-0 border-r border-[#E5E7EB] bg-[#F8F9FA] flex flex-col"
    >
      <div className="px-5 py-6 border-b border-[#E5E7EB]">
        <div className="flex items-center gap-2">
          <div className="h-8 w-8 bg-[#002FA7] text-white flex items-center justify-center">
            <Lightning weight="fill" size={18} />
          </div>
          <div>
            <div className="font-display font-black text-[15px] leading-none tracking-tight">
              PAINEL.BOT
            </div>
            <div className="label-mono mt-1">Control Room</div>
          </div>
        </div>
      </div>

      <nav className="flex-1 px-3 py-4 space-y-1">
        {items.map(({ to, label, icon: Icon, end }) => (
          <NavLink
            key={to}
            to={to}
            end={end}
            data-testid={`nav-${label.toLowerCase()}`}
            className={({ isActive }) =>
              `flex items-center gap-3 px-3 py-2 text-sm transition-colors duration-150 ${
                isActive
                  ? "bg-[#002FA7] text-white"
                  : "text-[#0F172A] hover:bg-white"
              }`
            }
          >
            <Icon size={18} weight="duotone" />
            <span>{label}</span>
          </NavLink>
        ))}
      </nav>

      <div className="px-3 py-4 border-t border-[#E5E7EB]">
        <div className="px-3 py-2 mb-2">
          <div className="label-mono">Conta</div>
          <div className="text-sm text-[#0F172A] truncate">{user?.email}</div>
        </div>
        <button
          data-testid="logout-btn"
          onClick={async () => {
            await logout();
            nav("/login");
          }}
          className="w-full flex items-center gap-3 px-3 py-2 text-sm text-[#0F172A] hover:bg-white transition-colors"
        >
          <SignOut size={18} weight="duotone" />
          <span>Sair</span>
        </button>
      </div>
    </aside>
  );
}
